import { useEffect, useState } from 'react';

const breakpoint0 = 575;
const breakpoint4 = 991;
const breakpoint5 = 992;
const breakpoint8 = 1440;

export interface ScreenSizeState {
  isTablet: boolean;
  isMobile: boolean;
  isSmallDesktop: boolean;
  isBigDesktop: boolean;
}

export enum ScreenSize {
  TABLET = 'tablet',
  MOBILE = 'mobile',
  SMALLDESKTOP = 'smallDesktop',
  BIGDESKTOP = 'bigDesktop',
}

export const queries: Record<ScreenSize, string> = {
  tablet: `(max-width: ${breakpoint4}px)`,
  mobile: `(max-width: ${breakpoint0}px)`,
  smallDesktop: `(min-width: ${breakpoint5}px) and (max-width: ${breakpoint8}px)`,
  bigDesktop: `(min-width: 1441px)`,
};

const matchMediaQuery = (query: ScreenSize): boolean =>
  window.matchMedia(queries[query]).matches;

export const useScreenSize = (): ScreenSizeState => {
  const [screenSize, setScreenSize] = useState<ScreenSizeState>({
    isTablet: matchMediaQuery(ScreenSize.TABLET),
    isMobile: matchMediaQuery(ScreenSize.MOBILE),
    isSmallDesktop: matchMediaQuery(ScreenSize.SMALLDESKTOP),
    isBigDesktop: matchMediaQuery(ScreenSize.BIGDESKTOP),
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        isTablet: matchMediaQuery(ScreenSize.TABLET),
        isMobile: matchMediaQuery(ScreenSize.MOBILE),
        isSmallDesktop: matchMediaQuery(ScreenSize.SMALLDESKTOP),
        isBigDesktop: matchMediaQuery(ScreenSize.BIGDESKTOP),
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};
